export function accountForUTC(date: Date, resetHours: boolean = false): Date {
  let dateString = date.toUTCString();
  let offset: number = date.getTimezoneOffset() / 60;

  if (Number.isInteger(offset)) {
    let offsetString = offset < 10 && offset > 0 ? '0' + offset : offset;
    dateString = dateString + (offset < 0 ? '+' : '-') + offsetString + '00';
  }

  let newDate = new Date(dateString);

  if (resetHours) {
    newDate.setHours(0);
    newDate.setMinutes(0);
    newDate.setSeconds(0);
    newDate.setMilliseconds(0);
  }

  return newDate;
}

export function getDifferenceInDays(date1: Date, date2: Date): number {
  const dayInSeconds = 1000 * 60 * 60 * 24;

  let difference = Math.abs(date1.valueOf() - date2.valueOf());

  let differenceInDays = Math.round(difference / dayInSeconds);

  return differenceInDays;
}

export function getLastMonth(month: number, year: number): Date {
  let date = new Date(year, month, 14);

  if (month !== 0) {
    date.setMonth(month - 1);
  } else {
    date.setFullYear(year - 1);
    date.setMonth(11);
  }

  date.setDate(1);

  return date;
}

export function getNextMonth(month: number, year: number): Date {
  let date = new Date(year, month, 14);

  if (month !== 11) {
    date.setMonth(month + 1);
    date.setDate(1);
  } else {
    date.setFullYear(year + 1);
    date.setMonth(0);
    date.setDate(1);
  }

  return date;
}

export function calculateLastDayOfMonth(month: number, year: number): number {
  let date = new Date(year, month, 14);

  if (month !== 11) {
    date.setFullYear(year);
    date.setMonth(month + 1);
  } else {
    date.setFullYear(year + 1);
    date.setMonth(0);
  }

  date.setDate(0);

  return date.getDay();
}

export function daysInMonth(month: number, year: number): number {
  // Since we're really dealing with UNIX timestamps,
  // let's set the date to the middle of the month to avoid
  // issues relating to "February doesn't have 30 days!" bugs.
  let date = new Date(year, month, 14);

  if (month !== 11) {
    date.setFullYear(year);
    date.setMonth(month + 1);
  } else {
    date.setFullYear(year + 1);
    date.setMonth(0);
  }

  date.setDate(0);

  return date.getDate();
}

export function getFirstDayOfMonth(month: number, year: number): number {
  let date = new Date();
  date.setDate(1);
  date.setMonth(month);
  date.setFullYear(year);

  return date.getDay();
}

// This expects the following format: MM/DD/YYYY
export function checkDate(value: string | Date) {
  if (typeof value === 'string') {
    let date = new Date(value);
    let temp = value.split('/');
    let dateParts: number[] = [];

    temp.forEach((part, i) => (dateParts[i] = Number.parseInt(part)));
    if (dateParts[0] !== 0) {
      dateParts[0] = dateParts[0] - 1;
    }

    // Even though 198 AD happened, we don't care.
    if (date.getFullYear() < 1000) {
      return false;
    }

    return (
      date.getMonth() === dateParts[0] &&
      date.getFullYear() === dateParts[2] &&
      date.getDate() === dateParts[1]
    );
  } else {
    return !isNaN(Number(value));
  }
}

export function padMonth(value) {
  const expiration = '00' + value;
  return expiration.slice(expiration.length - 2, expiration.length);
}

export function parseDates(datesRaw: string[]): Date[] {
  return datesRaw.reduce((datesParsed: Date[], dateRaw: string): Date[] => {
    const date = new Date(dateRaw);
    if (date instanceof Date && !isNaN(date.getTime())) {
      datesParsed.push(date);
    }

    return datesParsed;
  }, []);
}

export function includesDate(haystack: Date[], needle: Date): boolean {
  for (let date of haystack) {
    if (needle.getTime() === date.getTime()) {
      return true;
    }
  }

  return false;
}
